import React from 'react'
import { AiOutlineWhatsApp } from 'react-icons/ai'
import Digicard from '../images/digicard.png'

const Footer = () => {
  return (
    <div>
      <section className="pb-10 bg-gray-100 px-2">
        <div className="flex-col border-gray-400 rounded-3xl max-w-[600px] mx-auto flex items-center p-4">
          <h1 className="text-lg text-center mt-4 text-black font-bold" dir="rtl">
            דף זה פותח על ידי
          </h1>
          <a className="flex flex-col justify-center items-center hover:scale-105 duration-300 w-[200px]">
            <img src={Digicard} alt="logoIcon" className="w-full h-auto" />
          </a>
          <style jsx>{`
            @keyframes pulse {
              0%,
              100% {
                transform: scale(1);
              }
              50% {
                transform: scale(1.1);
              }
            }
          `}</style>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://wa.link/phhfl2"
            className="flex mx-auto w-[280px] items-center justify-center bg-green-600 px-4 py-2 mt-4 rounded-full shadow-md hover:bg-green-700 transition duration-300 ease-in-out"
          >
            <AiOutlineWhatsApp size={30} color="white" className="mr-2" style={{ animation: 'pulse 2s infinite' }} />
            <span className="text-sm font-medium text-white whitespace-nowrap" dir="rtl">
              לחצו כאן לרכישת כרטיס ביקור דיגיטלי
            </span>
          </a>
        </div>
        <div dir="ltr" className="flex justify-center mt-12">
          <a
            className="inline-flex items-center justify-center px-6 py-2 text-sm font-medium bg-white hover:bg-gray-100 rounded-2xl border border-gray-200 shadow-sm"
            href="https://idanshlomo.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="flex items-center">
              <span className="text-xs font-medium text-gray-600 mr-2">Made by</span>
              <img
                className="mr-2 transition-transform duration-300"
                src="/is-logo.svg"
                alt="Idan Shlomo Logo"
                width={25}
                height={25}
              />
              <span className="font-medium text-sm text-gray-800">Idan Shlomo</span>
            </span>
          </a>
        </div>
      </section>
    </div>
  )
}

export default Footer
